import { FinanceApplicationReportUIFilters } from '@/shared/ui-models/finance-application-report.ui-model';

export const initialFinanceApplicationsFiltersValues: FinanceApplicationReportUIFilters = {
  startDate: null,
  endDate: null,
  bookingStartDate: null,
  bookingEndDate: null,
  creationStartDate: null,
  creationEndDate: null,
  status: [],
  agent: [],
  financialMerchantId: { id: '', label: '' },
  source: []
};

export const validateFinanceApplicationReportFiltersForm = (
  fieldValues: FinanceApplicationReportUIFilters,
  errors: { [key: string]: string },
  setErrors: (error: any) => void,
  t: (key: string) => string
) => {
  const temp: { [key: string]: unknown } = { ...errors };

  if ('startDate' in fieldValues)
    temp.startDate = fieldValues.startDate
      ? ''
      : t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.START_DATE_REQUIRED');
  if ('endDate' in fieldValues)
    temp.endDate = fieldValues.endDate
      ? ''
      : t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.END_DATE_REQUIRED');
  if ('bookingStartDate' in fieldValues) temp.bookingStartDate = '';
  if ('bookingEndDate' in fieldValues) temp.bookingEndDate = '';
  if ('creationStartDate' in fieldValues) temp.creationStartDate = '';
  if ('creationEndDate' in fieldValues) temp.creationEndDate = '';

  if (fieldValues.startDate && fieldValues.endDate) {
    if (fieldValues.startDate > fieldValues.endDate) {
      temp.endDate = t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.END_DATE_GREATER_THAN_START');
    }
  }

  if (fieldValues.bookingStartDate && fieldValues.bookingEndDate) {
    if (fieldValues.bookingStartDate > fieldValues.bookingEndDate) {
      temp.bookingEndDate = t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.BOOKING_END_DATE_GREATER_THAN_START');
    }
  }

  if (fieldValues.creationStartDate && fieldValues.creationEndDate) {
    if (fieldValues.creationStartDate > fieldValues.creationEndDate) {
      temp.creationEndDate = t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.CREATION_END_DATE_GREATER_THAN_START');
    }
  }

  setErrors({
    ...temp
  });

  const isValidForm = Object.values(temp).every((x) => x === '');
  if (isValidForm) {
    return { valid: true, error: '' };
  } else {
    return {
      valid: false,
      error: t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.FILL_MANDATORY_DATA')
    };
  }
};
